import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { ParticipationConfigurations } from "@/types";
import { fetchParticipationConfigurations } from "./thunk";

export interface ParticipationConfigurationState {
  participationConfigurations: Partial<ParticipationConfigurations>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: ParticipationConfigurationState = {
  participationConfigurations: {},
  error: null,
  status: "idle"
};

export const participationConfigurationsSlice = createSlice({
  name: "participationConfigurations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[participationConfigurationsSlice.name]
        };
      })
      .addCase(fetchParticipationConfigurations.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchParticipationConfigurations.fulfilled, (state, action) => {
        state.status = "idle";
        state.participationConfigurations = action.payload;
      })
      .addCase(fetchParticipationConfigurations.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
